/************************************************
 * http://www.jq-school.com/Article.aspx?kid=471/
 * @author :leon.z xfl
 * @email  :LeonJsObj@126.com xflyyxfl@qq.com
 * @date   :2014-9-3
 * @description :自己写的alert和confirm弹出框,添加pop input close控制等
 ***********************************************/
/**
	自己写的alert和confirm弹出框。用法很简单，直接调用插件对象传人参数ok,
	注意的是自己无聊将插件升级为用户自定义，完全根据用户审美自定义颜色，再就是有一个全局颜色随机机制，如果您不是重口味，建议您不要开启,

	eg:$.MsgBox({type:"confirm",title:"",msg:"",opacity:'',callback:function(){}.....})
**/

// import * as $ from 'jquery';
// const $ = window.$;
let defaults =
{
    is_changeBg: true, //默认显示遮罩层
    title: '消息', //头部
    msg: '', //内容
    has_close:true,
    msg_pic:'',
    yes_txt:'确定',//
    no_txt:'取消',//
	title_style:'',//标题style
	msg_style:'',//消息style
	btn_box_style:'',//消息框按钮框style
	box_style:'',//消息框style
    opacity: .6, //遮罩层透明度
    bgColor: '#000', //遮罩层颜色
    type: 'alert', //调用类型（必须填写）alert confirm pop input
    default_value:'',//在input类型时默认值
    lazy_exit:false,//callback前就删除弹窗,true 先执行callback,删除弹窗在setTimeout 用于弹窗中的html控件被获取值
    show_time:'',//type pop有效，定义消息显示时间
    userDesign: false, //用户自定义（默认false）
    borderColor: "#009bfe", //title下边框颜色(只针对自定义下有效)
    titleBg: "#ddd", //title背景颜色(只针对自定义下有效)
    contentBg: "#fff", //内容背景(只针对自定义下有效)
    dashColor: "#ddd", //虚线颜色(只针对自定义下有效)
    btnBg: "#168bbb", //按钮颜色(只针对自定义下有效)
    iconHoverBg: "red", //关闭按钮放上去颜色(只针对自定义下有效)
    AllColorAuto: false, //是否启用全局颜色随机产生，启用后自定义的颜色将实效(只针对自定义下有效)
    btn_close:[true,true],//按钮后是否删除窗口
    callback: function() {}, //声明回调函数
    callback2: function() {},

};
const dom_from_str = function(str){
　　 var objE = document.createElement("div");
　　 objE.innerHTML = str;
　　 return objE.childNodes;
}
const msgbox = function(options) {
	    if(!window.$){
			console.warn('No jquery found! must include jquery');
			console.log(options);
			return;
		}
		let opts = Object.assign(JSON.parse(JSON.stringify(defaults)),options);
		if (!!opts.userDesign && opts.userDesign == !0) {
			if (!!opts.AllColorAuto && opts.AllColorAuto == !0) {
				var btnBg = '#' + (Math.random() * 0xffffff << 0).toString(16);
				var borderColor = '#' + (Math.random() * 0xffffff << 0).toString(16);
				var titleBg = '#ddd' //不敢随机，影响食欲
				var contentBg = '#fff'; //不敢随机，影响食欲
				var dashColor = '#' + (Math.random() * 0xffffff << 0).toString(16);
				var iconHoverBg = '#' + (Math.random() * 0xffffff << 0).toString(16);
			} else {
				var btnBg = opts.btnBg;
				var borderColor = opts.borderColor;
				var titleBg = opts.titleBg;
				var contentBg = opts.contentBg;
				var dashColor = opts.dashColor;
				var iconHoverBg = opts.iconHoverBg;
			}
		} else {
			var borderColor = "#009bfe";
			var titleBg = "#ddd";
			var contentBg = "rgb(173, 165, 165)";
			var dashColor = "#ddd";
			var btnBg = "rgb(53, 61, 64)";
			var iconHoverBg = "red";
		};

		(function(opts) {
			switch (opts.type) { //检查用户传进来的类型，目前只开发到alert,confirm两种
				case "alert":
					pageRender("alert", opts);
					btnOk(opts.callback);
					btnNo();
					break;
				case "confirm":
					pageRender("confirm", opts);
					btnOk(opts.callback);
					btnNo(opts.callback2);
					break;
				case "pop":
					pageRender("pop", opts);
					btnOk();
					btnNo();
					break;
				case "input":
					pageRender("input", opts);
					btnOk(opts.callback);
					btnNo(opts.callback2);
					break;
				default:
					pageRender("alert", '消息', "暂时未开发其他功能，请持续关注leon.z插件库");
					btnOk();
					btnNo();
					break;
			}
		})(opts);
		function pageRender(type, opt) { /** 渲染页面**/
			var html = "";
			html +='<div id="msg_box"></div><div id="msg_con">' + ((opt.title!=="")?'<span id="msg_tit">' + opt.title + '</span>':'');
			html += (opt.has_close?'<a id="msg_ico">x</a>':'') + '<div id="msg_msg">' + opt.msg;
			if(opt.msg_pic!=='')html += '<img id="msg_pic" src="' + opt.msg_pic + '">';
			if(type=='input'){
				html += '<input id="msg_input" type="text" value="' + opt.default_value + '">';
			};
			html += '</div><div id="msg_btnbox">';
			if (type == "alert") {
				html += '<div id="msg_btn_ok">'+opt.yes_txt+'</div>';
			}
			if (type == "confirm" || type == "input") {
				if(opt.yes_txt){
					html += '<div id="msg_btn_ok" >'+opt.yes_txt+'</div>';
				};
				if(opt.no_txt){
					html += '<div id="msg_btn_no">'+opt.no_txt+'</div>';//定义空或者无取消按钮
				}

			}
			html += '</div></div>';
			//必须先将html添加到body，再设置Css样式
			$("body").append(html);
			//if($('#msg_msg img').length !=0 || $('#msg_msg input').length !=0 || opt.msg.indexOf('<br>')!=-1){
			if(/<[^>]+>/g.test(opt.msg)){
				//如果是html字符串
				opt.lazy_exit = true;
				$('#msg_msg').html(opt.msg);
			};
			renderCss(); //渲染样式
			if(type=='input'){
				$('#msg_input').get(0).addEventListener( 'keydown', function ( event ) {
					event.stopPropagation();
				}, false );//去除输入框事件传递
			};

			if(opt.show_time!=="" && type =="pop"){
				setTimeout(function(){$('#msg_box').fadeOut(1200);setTimeout(function(){$("#msg_box,#msg_con").remove();},1000);},opt.show_time*1+10);
			}
		};
		function renderCss() {
				var msgBox = document.body.clientWidth > 400 ? 300 : document.body.clientWidth - 10;
				if (opts.is_changeBg == !0) {
					$("#msg_box").css({
						width: '100%',
						height: '100%',
						zIndex: '99999',
						position: 'fixed',
						backgroundColor: opts.bgColor,
						top: '0',
						left: '0',
						opacity: opts.opacity
					});
				} else {
					$("#msg_con").css({
						border: "1px solid " + borderColor,
						boxShadow: "0px 2px 0px " + borderColor
					});
				}
				$("#msg_con").css({
					zIndex: '999999',
					//width: msgBox + 'px',
					minWidth:msgBox+'px',
					//maxHeight:msgBox*2+'px',
					position: 'fixed',
					backgroundColor: contentBg,
					borderRadius: '15px',
					cursor: 'pointer'
				});

				$("#msg_tit").css({
					display: 'block',
					fontSize: '14px',
					color: '#444',
					padding: '8px 3px',
					backgroundColor: titleBg,
					borderRadius: '15px 15px 0 0',
					/*borderBottom: '3px solid ' + borderColor,*/
					fontWeight: 'bold',
				});
				opts.title_style && $("#msg_tit").attr('style',$("#msg_tit").attr('style')+opts.title_style);
				$("#msg_msg").css({
					padding: '8px',
					lineHeight: '20px',
					textAlign:'left',
					maxWidth:'800px',
					maxHeight:'600px',
					overflow:'auto',
					/*borderBottom: '1px dashed ' + dashColor,*/
					fontSize: '12px'
				});
				opts.msg_style && $("#msg_msg").attr('style',$("#msg_msg").attr('style')+opts.msg_style);
				$("#msg_pic").css({
					//maxWidth:document.body.clientWidth*2/2+'px'
				});

				$("#msg_input").css({
					margin:'7px 5px',
					width:'60%',
					height:'25px'
				});

				$("#msg_ico").css({
					display: 'block',
					position: 'absolute',
					right: '10px',
					top: '3px',
					border: '1px solid Gray',
					width: '18px',
					height: '18px',
					textAlign: 'center',
					lineHeight: '15px',
					cursor: 'pointer',
					borderRadius: '12px',
					fontFamily: '微软雅黑'
				});
				$("#msg_btnbox").css({
					margin: '4px 0 3px 0',
					textAlign: 'center'
				});
				$("#msg_btn_ok,#msg_btn_no").css({
					//width: '75px',
					padding:'4px 2px 4px 2px',
					//height: '18px',
					display:'inline-block',
					color: 'white',
					fontSize: '11px',
					border: '1px solid green',
					"border-radius":'9px',
					cursor: 'pointer'
				});
				$("#msg_btn_ok").css({
					backgroundColor: btnBg
				});
				$("#msg_btn_no").css({
					backgroundColor: 'gray',
					marginLeft: '20px'
				});
				//右上角关闭按钮hover样式
				$("#msg_btn_ok,#msg_btn_no").hover(function() {
					var hoverClass = {
						"transition-property": "all",
						"transition-duration": "0.3s",
						"transition-timing-function": "ease-in",
						"transition-delay": "0.05s",
						"border": '1px solid red',
						"color": "white"
					}
					if (window.applicationCache) { //是否支持html5 transition属性
						$(this).css(hoverClass || {});
					} else {
						$(this).css({
							"border": '1px solid red',
							color: 'white'
						});
					}
				}, function() {
					$(this).css({
						"border": '1px solid green',
						/*color: 'black'*/
					});
				});
								$("#msg_ico").hover(function() {
					var hoverClass = {
						"transition-property": "all",
						"transition-duration": "0.3s",
						"transition-timing-function": "ease-in",
						"transition-delay": "0.05s",
						"backgroundColor": iconHoverBg,
						"color": "white"
					}
					if (window.applicationCache) { //是否支持html5 transition属性
						$(this).css(hoverClass || {});
					} else {
						$(this).css({
							backgroundColor: iconHoverBg,
							color: 'white'
						});
					}
				}, function() {
					$(this).css({
						backgroundColor: titleBg,
						color: 'black'
					});
				});


				function set_center(){

					var _widht = window.screen.clientWidth || document.documentElement.clientWidth; //屏幕宽
					var _height = window.screen.clientHeight || document.documentElement.clientHeight; //屏幕高
					var msgBoxidth = $("#msg_con").width();
					var boxHeight = $("#msg_con").height() + 100;
					//让提示框居中
					$("#msg_con").css({
						top: (_height - boxHeight) / 2 + "px",
						left: (_widht - msgBoxidth) / 2 + "px"
					});


				}
				$('#msg_con img').on('load',()=>{
					console.log('img load');
					set_center();
				})
				// let img_array = $('#msg_con img');
				// if(img_array.length>0){
				// 	img_array.each(function(){
				// 		$(this).load(function(){
				// 			console.log('img load done');
				// 			set_center();
				// 			});
				// 	});
				// };
				set_center();



			}
		//确定按钮事件
		function btnOk(callback) {
				$("#msg_btn_ok").click(function() {
					let value = $('#msg_input').val();//提前获取输入弹窗的值
					if(opts.btn_close[0]){
						if(opts.lazy_exit){
							setTimeout(()=>$("#msg_box,#msg_con").remove(),10);
						}else{
							$("#msg_box,#msg_con").remove();
						}
					};
					if (typeof(callback) == 'function') {
						if(opts.type=='input'){

							callback(value);
						}else{
							callback();
						}

					};

				});
			}
		//取消按钮事件

		function btnNo(callback) {
			//添加x退出事件
			$("#msg_ico").click(function() {
				if(opts.btn_close[0]){
					if(opts.lazy_exit){
						setTimeout(()=>$("#msg_box,#msg_con").remove(),100);
					}else{
						$("#msg_box,#msg_con").remove();
					}
				};
				if(opts.type=='input')callback();//如果是输入类型弹窗，当取消
			});

			$("#msg_btn_no").click(function(){
				if(opts.btn_close[0]){
					if(opts.lazy_exit){
						setTimeout(()=>$("#msg_box,#msg_con").remove(),100);
					}else{
						$("#msg_box,#msg_con").remove();
					}
				};
				if (typeof(callback) == 'function') {
						callback();
					}

			})

		}
	}

export {msgbox}
